export const iconFontAwesomeDesignSprayCan = (
	<i className="fa-solid fa-spray-can"></i>
);
